const NoMatch = () => (
  <div>Not Found</div>
);

export default NoMatch;